import { render, staticRenderFns } from "./EditDogModal.vue?vue&type=template&id=3908a023&"
import script from "./EditDogModal.vue?vue&type=script&lang=js&"
export * from "./EditDogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports